module.exports = __webpack_public_path__ + "media/images/flags/GG-374d1068b1dd9e5d2ec8084bb28c850b.svg";